import { AdacText } from '@adac-de/component-library';
import { clsx } from 'clsx';
import React from 'react';
import styles from './centered-text.module.scss';

export const CenteredText: React.FC<{ children: React.ReactNode | string; className?: string }> = ({
  children,
  className
}) => (
  <AdacText type="medium" className={clsx(styles.centeredText, className)}>
    {children}
  </AdacText>
);
